import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tidy-roi-bar',
  templateUrl: './roi-bar.component.html',
  styleUrls: ['./roi-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class RoiBarComponent {
  @Input() score: number | null | undefined = null;
  @Input() label = '—';
  @Input() percent = 0;
  @Input() compact = false;
}
